import { Component } from '@angular/core';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-institucional',
  templateUrl: 'institucional.html',
})
export class InstitucionalPage {
  institucional:any = {};

  constructor(private dadosP:DadosProvider) {

    if(dadosP.configuracao){
      this.institucional.missao = dadosP.configuracao.missao;
      this.institucional.visao = dadosP.configuracao.visao;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/institucional/institucional.ts